import React, { createContext, useCallback, useContext, useState } from 'react';

type AccordionContextType = {
    openedState: Set<string>;
    toggleOpenedState: (id: string) => void;
};

const AccordionContext = createContext<AccordionContextType>({
    openedState: new Set(),
    toggleOpenedState: () => {},
});

export const useAccordion = () => useContext(AccordionContext);

const AccordionGroup = ({ children }) => {
    const [openedState, updateOpenedState] = useState(new Set());

    const toggleOpenedState = useCallback(
        (id) => {
            const state = new Set([...openedState]);
            state.has(id) ? state.delete(id) : state.add(id);

            updateOpenedState(state);
        },
        [openedState]
    );

    return (
        <AccordionContext.Provider value={{ openedState, toggleOpenedState }}>
            {children}
        </AccordionContext.Provider>
    );
};

export default AccordionGroup;
